import { supabase } from '../supabase';

export const uploadCompanyDocument = async ({
  file,
  idAzienda,
  uploadedBy,
  tipologia,
  anno,
  validoDal = null,
  validoAl = null,
  note = null
}) => {
  try {
    // 1. Sanitize file name & Build path
    const fileExt = file.name.split('.').pop();
    const cleanFileName = file.name.replace(/[^a-zA-Z0-9.-]/g, '_');
    const filePath = `company_docs/${idAzienda}/${Date.now()}_${cleanFileName}`;

    // 2. Upload to Supabase Storage ('aziende' bucket)
    const { data: uploadData, error: uploadError } = await supabase.storage
      .from('aziende')
      .upload(filePath, file, { cacheControl: '3600', upsert: false });

    if (uploadError) throw uploadError;

    // 3. Insert record into `documenti_azienda` table
    const { data: docData, error: dbError } = await supabase
      .from('documenti_azienda')
      .insert([
        {
          id_azienda: idAzienda,
          uploaded_by: uploadedBy,
          nome_file: file.name,
          file_path: filePath,
          tipologia,
          anno: parseInt(anno, 10),
          valido_dal: validoDal || null,
          valido_al: validoAl || null,
          note: note || null,
          is_deleted: false
        }
      ])
      .select()
      .single();

    if (dbError) throw dbError;

    return { success: true, data: docData };
  } catch (err) {
    console.error('Error uploading company document:', err);
    throw err;
  }
};